import { createPortal } from 'react-dom';

export const TooltipPortal = ({ children }: { children: React.ReactNode }) =>
  createPortal(children, document.body);
